<template>
  <div id="map" ref="map"></div>
</template>

<script>
import "ol/ol.css";
import { Map, View, Geolocation, Feature } from "ol";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { Vector, OSM } from "ol/source";
import KML from "ol/format/KML";
import { Control, defaults as defaultControls } from "ol/control";
import { Icon, Style } from "ol/style";
import Point from "ol/geom/Point";
import axios from "axios";

export default {
  name: "Map",
  data() {
    return {
      tracking: false
    };
  },
  async mounted() {
    const geoData = await axios
      .get("/data/map/stops.kml")
      .then(response => response.data);
    this.loadMap(geoData);
  },
  methods: {
    /*
     * To who ever inherits this project... I am extremely sorry about this function.
     * I hope Todd/Paul doesn't want you to mess with it too much.
     */
    loadMap(geoData) {
      const vectorLayer = new VectorLayer({
        source: new Vector({
          features: new KML().readFeatures(geoData, {
            featureProjection: "EPSG:3857"
          })
        })
      });

      const rasterLayer = new TileLayer({
        source: new OSM()
      });

      const view = new View({
        center: [-8952512.934122562, 4470887.201393357],
        extent: [-8953750, 4469000, -8951250, 4472500],
        zoom: 15.5,
        minZoom: 15,
        maxZoom: 18
        // rotation: Math.PI / 8
      });

      const geolocation = new Geolocation({
        trackingOptions: {
          enableHighAccuracy: true
        },
        projection: view.getProjection()
      });

      const TrackMe = /*@__PURE__*/ (function(Control) {
        function TrackMe(opt_options) {
          const options = opt_options || {};

          const button = document.createElement("button");
          const img = document.createElement("img");
          img.src = require("@/assets/map-location.png");
          button.appendChild(img);

          const element = document.createElement("div");
          element.className = "ol-control ol-find-me";
          element.appendChild(button);

          Control.call(this, {
            element: element,
            target: options.target
          });

          button.addEventListener("click", this.trackUser.bind(this), false);
        }

        if (Control) TrackMe.__proto__ = Control;
        TrackMe.prototype = Object.create(Control && Control.prototype);
        TrackMe.prototype.constructor = TrackMe;

        TrackMe.prototype.trackUser = function trackUser() {
          this.tracking = !this.tracking;
          geolocation.setTracking(this.tracking);
        };

        return TrackMe;
      })(Control);

      geolocation.on("error", error => {
        this.tracking = false;
        this.$buefy.dialog.alert({
          message: `Could not start tracking. Error: ${error.message}.`,
          canCancel: ["button"],
          size: "is-small"
        });
      });

      const positionFeature = new Feature();
      positionFeature.setStyle(
        new Style({
          image: new Icon({
            anchor: [0.5, 1],
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            scale: [0.125, 0.125],
            src: require("@/assets/map-location.png")
          })
        })
      );

      geolocation.on("change:position", function() {
        const coordinates = geolocation.getPosition();
        positionFeature.setGeometry(
          coordinates ? new Point(coordinates) : null
        );
      });

      const map = new Map({
        target: this.$refs["map"],
        layers: [rasterLayer, vectorLayer],
        controls: defaultControls({
          attribution: false,
          rotate: false
        }).extend([new TrackMe()]),
        view: view
      });

      new VectorLayer({
        map: map,
        source: new Vector({
          features: [positionFeature]
        })
      });

      map.on("click", event => {
        map.forEachFeatureAtPixel(event.pixel, selected => {
          if (selected.getId() !== null) {
            const id = selected.getProperties().description;
            const location = selected.getProperties().geometry.flatCoordinates;
            this.$emit("selectedStop", id);
            map.getView().setCenter(location);
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#map {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>

<style lang="scss">
.ol-zoom {
  top: 0.5em;
  right: 0.5em;
  left: auto;
  bottom: auto;
}

.ol-find-me {
  top: calc(0.5em + 73px);
  right: 0.5em;
  left: auto;
  bottom: auto;
  button {
    width: 33px;
    height: 33px;
    padding: 0.22em;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      object-position: center;
    }
  }
}
</style>
